export default {"src":"/_next/static/media/Ellipse.f814d636.svg","height":390,"width":390,"blurWidth":0,"blurHeight":0};